export const setCookie = (name: string, value: string, days = 7): void => {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    const expires = `expires=${date.toUTCString()}`;
    const secure = window.location.protocol === 'https:' ? '; secure' : '';
    document.cookie = `${name}=${value}; ${expires}; path=/; SameSite=Strict${secure}`;
};

export const getCookie = (name: string): string | null => {
    const nameEQ = `${name}=`;
    const cookies = document.cookie.split(';');

    for (const element of cookies) {
        let cookie = element;
        while (cookie.startsWith(' ')) {
            cookie = cookie.substring(1, cookie.length);
        }
        if (cookie.startsWith(nameEQ)) {
            return cookie.substring(nameEQ.length, cookie.length);
        }
    }
    return null;
};

export const deleteCookie = (name: string): void => {
    document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict`;
};
